module.exports = __webpack_public_path__ + "static/media/bulma-logo.6bf9b4da.png";